/* eslint-disable import/no-extraneous-dependencies */

import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';

const StyledTextField = styled(TextField)({
  '& input:valid + fieldset': {
    borderColor: 'palette.primary.main'
  },
  '& input:invalid + fieldset': {
    borderColor: 'palette.error.main'
  },
  '& input:valid:focus + fieldset': {
    borderColor: 'palette.primary.main'
  },
  width: '100%'
});

export default StyledTextField;
